export default class Ledger {
    public ledgerId: number = null;
    public name: string = '';
    public value: string = '';
    public description: string = '';
}
